import React from 'react'
import PropTypes from 'prop-types'
import PassportBookings from './passport-bookings'
import PassportDefault from './profile/default'
import PassportCorporate from './profile/corporate'

const PassportProfile = ({
  subscription: {
    id,
    type,
    plan: title,
    status,
    location,
    locationSlug,
    noOfPasses,
    date: startDate,
    end_date: endDate,
    invitedMembers,
    is_recurrent: isRecurrent,
    nextBill,
    price,
    user_id,
  },
}) => {
  const data = Object.assign({},
    {
      id,
      title,
      status,
      location,
      locationSlug,
      noOfPasses,
      startDate,
      endDate,
      invitedMembers,
      isRecurrent,
      nextBill,
      price,
      user_id,
    },
  )
  const renderProfile = () => {
    switch (type) {
      case 'corporate':
        return <PassportCorporate {...data} />
      default:
        return <PassportDefault {...data} />
    }
  }

  return (
    <>
      <div className="w-full md:w-1/2">
        <PassportBookings />
      </div>
      {renderProfile()}
    </>
  )
}

PassportProfile.propTypes = {
  subscription: PropTypes.object.isRequired,
}

export default PassportProfile
